const ProcessRolesProductBased = (source, target, shouldCheckCondition) => {
  source?.forEach((role) => {
    if (shouldCheckCondition ? role?.label && !target.includes(role.label) : true) {
      target.push(role?.label);
    }
  });
};
export default ProcessRolesProductBased;
